import { useLocation, useNavigate } from 'react-router-dom';
import Badge from 'components/UI/Badge';
import { CurrencyFormatDisplay } from 'components/UI/NumberFormatDisplay/CurrencyFormatDisplay';
import Table from 'components/UI/Table';
import { convertEnumToText } from 'utils';
import { ChicagoRebuildFiltersForm } from './ChicagoRebuildFiltersForm';
import { useApplicationsListContext } from 'features/ApplicationForm/Components/ApplicationsList/ApplicationsListProvider';

export default function ChicagoRebuildApplications() {
  const {
    data,
    tablePagination,
    showFilterModal,
    toggleFilterModal,
    applyFiltersHandler,
  } = useApplicationsListContext();

  const navigate = useNavigate();
  const location = useLocation();

  const tableColumns = [
    {
      id: 'businessName',
      Header: 'Business Name',
      accessor: 'applicationData',
      minWidth: 250,
      maxWidth: 250,
      Cell: (row: any) => {
        const orgInfo = row.value?.organizationInformation;
        return (
          <div className='text-sm text-neutralColor-medium flex flex-col max-w-md'>
            <span className='truncate'>{orgInfo?.businessName}</span>
            <div className='flex flex-col gap-1 text-xs text-neutralColor-normal'>
              <span>
                {orgInfo?.businessAddress}, {orgInfo?.businessCity},{' '}
                {orgInfo?.state}, {orgInfo?.zipCode}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      id: 'sponsor',
      Header: 'Sponsor',
      accessor: 'applicationData',
      minWidth: 250,
      maxWidth: 250,
      Cell: (row: any) => {
        const sponsor = row.value?.organizationInformation?.sponsors[0];
        return (
          <div className='text-sm text-neutralColor-medium flex flex-col max-w-md'>
            <span className='truncate'>
              {sponsor.isCorporate
                ? `${sponsor.leadContact} (corporate)`
                : sponsor.name}
            </span>
            {sponsor.isCorporate && (
              <div className='flex flex-col gap-1 text-xs text-neutralColor-normal'>
                {sponsor?.contactEmail}
              </div>
            )}
            {!sponsor.isCorporate && (
              <div className='flex flex-col gap-1 text-xs text-neutralColor-normal'>
                <span>
                  {sponsor?.address}, {sponsor?.city}, {sponsor?.state},{' '}
                  {sponsor?.zipCode}
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      id: 'amountRequested',
      Header: 'Amount Requested',
      accessor: 'applicationData',
      minWidth: 200,
      maxWidth: 200,
      Cell: (row: any) => {
        const financialRequest = row?.value.financialRequest.loanRequest;
        return (
          <CurrencyFormatDisplay
            value={financialRequest.loanRequestAmount}
            prefix='$'
          />
        );
      },
    },
    {
      id: 'socialDesignation',
      Header: 'Social Designation',
      accessor: 'applicationData',
      minWidth: 200,
      maxWidth: 200,
      Cell: (row: any) => {
        const orgInfo = row.value?.organizationInformation;
        return <>{orgInfo?.socialDesignation}</>;
      },
    },
    {
      id: 'status',
      Header: 'Status',
      accessor: 'status',
      minWidth: 250,
      maxWidth: 250,
      Cell: (row: any) => {
        return <Badge status={row.value} text={convertEnumToText(row.value)} />;
      },
    },
  ];

  return (
    <>
      <Table
        cols={tableColumns}
        tableData={data?.data}
        onRowClick={(row: any) => navigate(`${location.pathname}/${row.id}`)}
        pagination={tablePagination}
      />
      {showFilterModal && (
        <ChicagoRebuildFiltersForm
          handleModal={toggleFilterModal}
          handleApplyFilter={applyFiltersHandler}
        />
      )}
    </>
  );
}
